import React from 'react';
import { i18n } from "react-i18n";
import moment from 'moment';
import { Activity } from 'ppgf-components';

import { parseMessages } from '../../utilityHelper';

const activityData = $('body').data();

const activityMsg = parseMessages("ppgf/components/activity");

export default class PpgfActivityComponent extends React.Component {
	constructor(props){
        super(props);
        this.state = {
			activityData: activityData.body,
			fromDate: '',
			toDate: '',
			minFromDate: '',
			maxFromDate: moment(),
			minToDate: '',
			maxToDate: moment(),
			startDate: '',
			endDate:'',
			flowType: this.props.flowType || 'common'
		}
        this.gettingNewTransactions = this.gettingNewTransactions.bind(this);
        this.downloadCSV = this.downloadCSV.bind(this);

    }

    gettingNewTransactions(params){
    	const self = this;
        let url = '';
        if (self.state.flowType === 'partner') {
        	url = '/givingfund/partner/activity/results';
        } else {
        	url = '/givingfund/activity';
        }
        
		$.post(url, params, function(result){
			if (result.status === 'error') {
				$('#loadmorespinner').hide();
			} else if(result.redirectUrl){
				window.location.href = result.redirectUrl;
			} else {
				params.transactions = result.transactions;
				params.pageNo = result.pageNo;
				self.setState({
					activityData: params
				});
			}
		});
		
    }

	downloadCSV(params){
    	const self = this;
		if (self.state.flowType === 'partner') {
        	location.href = '/givingfund/partner/activity.csv?donorName=' + params.donorName + '&fromDate=' + params.fromDate + '&toDate=' + params.toDate;
        } else {
        	location.href = '/givingfund/activity.csv?donorName=' + params.donorName + '&fromDate=' + params.fromDate + '&toDate=' + params.toDate + '&searchType=date&partner=' + params.partner + '&program=' + params.program;
        }
    }

	render() {
		const error = this.state.activityData.errorType;
		if(!error){
			return ( 
				<div className="container">
					<Activity 
						flowType={this.state.flowType}
						activityData={this.state.activityData}
						activityMsg={activityMsg}
						gettingNewTransactions={(params)=>this.gettingNewTransactions(params)}
						downloadCSV={(params)=>this.downloadCSV(params)}
						datepattern={activityData.datepattern}
					/>
				</div>
			);
		} else {
			return (<div><ErrorComponent errorType={error}/></div>);
		}
	}
}



// WEBPACK FOOTER //
// ./ppgf/components/activity.js